export const ApiEntityRates = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async (year, id, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${id}/rates/${year}`)
    return result.data
  }

  const save = async (year, id, payload, module = 'accommodations') => {
    const result = await axios.post(`/api/entities/${module}/${id}/rates/${year}/`, payload)
    return result.data
  }

  return {
    entityRatesLoad: load,
    entityRatesSave: save
  }
}
